// Constants for different requests for current reducer
export default {
  login: 'LOGIN',
  logout: 'LOGOUT',
  resetLogin: 'RESET_LOGIN',
  expiredModal: 'EXPIRED_MODAL',
  acceptAgreement: 'acceptAgreement',
};
